


























































import { createDecorator } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { logIn, logOut } from '@/auth/auth';
import { MapGetters } from '@/utils/vuexHelpers';

@Component
@MapGetters('auth', ['auth'])
export default class AuthenticatedView extends Vue {
  showBackButtonTimer: any = null;
  showBackButton: boolean = false;

  mounted() {
    // Set a timer in case the auth event registered in authUtils doesn't fire for some reason.
    // The timer first tries to call the logIn method to possibly perform the login anyways
    // and falls back to displaying an error message and a link back to the login page
    this.showBackButtonTimer = setTimeout(async () => {
      try {
        await logIn();
      } catch (e) {
        this.showBackButton = true;
      }
    }, 5000);
  }

  beforeDestroy() {
    clearTimeout(this.showBackButtonTimer);
  }

  logout() {
    logOut();
  }
}
